module.exports = __webpack_public_path__ + "img/3.2ac63389.svg";